const BaseController = require('base/controller/loadDataController'),
    RequestAccessView = require('./requestAccessView');

const Controller = BaseController.extend({
    data: function () {
        return {
            countries: { collection: '/requestAccess/country/lookup' },
            defaultPasswordPolicy: { model: `/requestAccess/passwordPolicy/default` },
            usaStates: { collection: '/requestAccess/usaState/lookup' },
            cellCarriers: { collection: '/requestAccess/cellCarrier/lookup' },
            languages: { collection: '/requestAccess/language' },
            timeZones: { collection: `/requestAccess/timeZone` },
        };
    },
    unauthorized: true,
    render: function () {
        let view = new RequestAccessView({
            countries: this.data.countries,
            defaultPasswordPolicy: this.data.defaultPasswordPolicy,
            usaStates: this.data.usaStates,
            cellCarriers: this.data.cellCarriers,
            languages: this.data.languages,
            timeZones: this.data.timeZones,
        });
        return view;
    }
});

module.exports = new Controller();
